// IE 2026 10 17 / ODOO-5800 (chain; поручение Игоря 17.10 «делай» по постановке «цепочка сигналов согласования»): строки цепочки согласования по уровням для блока
// APPROVAL (uk ЗАТВЕРДЖЕННЯ) формы ячейки под WORKFLOW v2 — «сигнал (утверждено / не утверждено) → причина (переход) → ответственный → срок».
// Контракт бэка (common_modules/approval_signals.chain_for_unit → approval_v2.cell_block.chain[]): [{level, status, status_title, state: 'approved' | 'pending' | 'cancelled' | 'frozen',
// metric: 'plan_approved' | 'plan_not_approved', reason, reason_title, responsible: {user, name, role, role_title} | null, due 'YYYY-MM-DD' | '', by: {user, name}, at (ISO),
// grade: 'ok' | 'info' | 'warning' | 'critical', text, unit}]. Пустой chain (бэк без цепочки / выключатель not-approval_signal_chain) — строк нет, блок прежний.
// Выключатель fe.ux.approvalChain (по умолчанию вкл.). Тест: tests/unit/approvalChain.test.mjs
import { t } from '@/i18n'
import { approvalTime, approvalTimeTip } from '@/utils/approval'

export const APPROVAL_CHAIN_FLAG = 'fe.ux.approvalChain'
export function approvalChainOn(setting) {
    try { return typeof setting !== 'function' || setting(APPROVAL_CHAIN_FLAG, true) !== false } catch (e) { return true }
}

const isObj = (v) => v !== null && typeof v === 'object' && !Array.isArray(v)
const has = (v) => v !== undefined && v !== null && v !== ''
const str = (v) => (has(v) ? String(v) : '')
const num = (v) => { const n = Number(v); return Number.isFinite(n) ? n : null }

export const CHAIN_STATES = ['approved', 'pending', 'cancelled', 'frozen']
// значок состояния строки: ✔ утверждено · ○ не утверждено · ● текущий уровень (утверждён, единица стоит на нём) · ✕ отменено · ❄ заморожено
const MARKS = { approved: '✔', current: '●', pending: '○', cancelled: '✕', frozen: '❄' }
const STATE_TITLES = { approved: 'Approved', pending: 'Not approved', cancelled: 'Cancelled', frozen: 'Frozen' }
const GRADES = { ok: '', info: '', warning: 'is-grade-warning', critical: 'is-grade-critical' }

function stateOf(r) {
    const s = str(r.state).toLowerCase()
    if (CHAIN_STATES.includes(s)) return s
    return str(r.metric) === 'plan_approved' ? 'approved' : 'pending'   // бэк без state — по сигналу
}

// chain[] объекта v2 (сам объект v2 бэка либо модель approvalV2Model с полем chain) — массив строк либо []
export function approvalChainOf(v2) {
    if (!isObj(v2) || !Array.isArray(v2.chain)) return []
    return v2.chain.filter(isObj)
}

// строки цепочки для шаблона, по уровням (level по возрастанию; строки без уровня — в конце). opts: {now, utc}
// → [{key, level, state, stateTitle, current, mark, statusTitle, reasonText, reasonTip, responsible, responsibleRole, due, dueText, dueTip, dueLabel, grade, gradeCss, byName, atText, atTip, tip}]
export function approvalChainRows(v2, opts = {}) {
    const chain = approvalChainOf(v2)
    if (!chain.length) return []
    const rows = chain.map((r, i) => ({ r, i, level: num(r.level), state: stateOf(r) }))
    rows.sort((a, b) => ((a.level === null ? Infinity : a.level) - (b.level === null ? Infinity : b.level)) || (a.i - b.i))
    // текущий уровень: уровень единицы (v2.level), иначе — наибольший утверждённый
    const approvedLevels = rows.filter(x => x.state === 'approved' && x.level !== null).map(x => x.level)
    const unitLevel = num(v2.level)
    const curLevel = unitLevel !== null && approvedLevels.includes(unitLevel) ? unitLevel : (approvedLevels.length ? Math.max(...approvedLevels) : null)
    return rows.map(({ r, i, level, state }) => {
        const current = state === 'approved' && level !== null && level === curLevel
        const grade = str(r.grade).toLowerCase()
        const due = str(r.due).slice(0, 10)
        const resp = isObj(r.responsible) ? r.responsible : null
        const by = isObj(r.by) ? r.by : (has(r.by) ? { name: str(r.by) } : null)
        const at = state === 'approved' || state === 'cancelled' || state === 'frozen' ? str(r.at) : ''
        const reasonTitle = str(r.reason_title) || str(r.reason)
        return {
            key: 'ch' + (level === null ? 'x' + i : level) + '-' + state,
            level, state, stateTitle: t(STATE_TITLES[state]), current,
            mark: current ? MARKS.current : MARKS[state],
            statusTitle: str(r.status_title) || str(r.status),
            reasonText: reasonTitle ? (state === 'pending' ? t('expected: {reason}', { reason: reasonTitle }) : reasonTitle) : '',
            reasonTip: str(r.reason),
            responsible: resp ? (str(resp.name) || str(resp.user)) : '',
            responsibleRole: resp ? (str(resp.role_title) || str(resp.role)) : '',
            responsibleTip: resp ? [str(resp.user), str(resp.role)].filter(Boolean).join(' · ') : '',
            due, dueText: due ? approvalTime(due, opts) : '', dueTip: due ? approvalTimeTip(due) : '',
            dueLabel: due ? (state === 'pending' ? t('due {date}', { date: approvalTime(due, opts) }) : t('until {date}', { date: approvalTime(due, opts) })) : '',
            grade, gradeCss: GRADES[grade] || '',
            byName: by && state !== 'pending' ? (str(by.name) || str(by.user)) : '',
            atText: at ? approvalTime(at, opts) : '', atTip: at ? approvalTimeTip(at) : '',
            tip: str(r.text),
        }
    })
}
